<template>
  <section
    v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row justify-center text-center">
        <div class="col-xl-8 col-lg-9 col-md-10">
          <div
            class="overflow-hidden js-section-slider"
            data-gap="30"
            data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1"
            data-pagination="js-pagination"
            data-custom-pagination="true"
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="review in reviews" :key="review._id">
                <div class="testimonials -type-1" :style="`color: var(--c-${vars.textColor})`">
                  <div
                    class="testimonials__icon tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6"
                  >
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_217_861)">
                        <path
                          d="M11.1468 1.05274C7.94946 2.16191 5.19211 4.26716 3.27973 7.05924C1.36735 9.85133 0.400732 13.1831 0.52186 16.5652C0.642987 19.9472 1.84547 23.2013 3.9527 25.8494C6.05992 28.4975 8.9608 30.4001 12.2293 31.2777C14.8791 31.9615 17.6553 31.9915 20.3193 31.3652C22.7325 30.8232 24.9637 29.6637 26.7943 28.0002C28.6995 26.2161 30.0823 23.9464 30.7943 21.4352C31.5681 18.7044 31.7057 15.8326 31.1968 13.0402H16.3168V19.2127H24.9343C24.762 20.1972 24.393 21.1368 23.8491 21.9753C23.3053 22.8138 22.5979 23.534 21.7693 24.0927C20.717 24.7888 19.5307 25.2572 18.2868 25.4677C17.0391 25.6997 15.7594 25.6997 14.5118 25.4677C13.2472 25.2063 12.051 24.6844 10.9993 23.9352C9.30962 22.7392 8.04094 21.0401 7.37425 19.0802C6.69629 17.0837 6.69629 14.9193 7.37425 12.9227C7.84882 11.5233 8.63334 10.2491 9.66925 9.19524C10.8547 7.96711 12.3556 7.08923 14.0071 6.65793C15.6587 6.22663 17.3972 6.25857 19.0318 6.75024C20.3087 7.14222 21.4764 7.82708 22.4418 8.75024C23.4134 7.78357 24.3834 6.81441 25.3518 5.84274C25.8518 5.32024 26.3968 4.82274 26.8893 4.28774C25.4157 2.91643 23.686 1.84938 21.7993 1.14774C18.3635 -0.099786 14.6042 -0.133312 11.1468 1.05274Z"
                          fill="white"
                        />
                        <path
                          d="M11.1489 1.05249C14.6061 -0.134368 18.3654 -0.101725 21.8014 1.14499C23.6884 1.8514 25.4174 2.92358 26.8889 4.29999C26.3889 4.83499 25.8614 5.33499 25.3514 5.85499C24.3814 6.82332 23.4122 7.78832 22.4439 8.74999C21.4785 7.82683 20.3108 7.14197 19.0339 6.74999C17.3998 6.25659 15.6615 6.22281 14.0095 6.65235C12.3575 7.08188 10.8557 7.95814 9.66891 9.18499C8.63299 10.2388 7.84847 11.513 7.37391 12.9125L2.19141 8.89999C4.04643 5.22139 7.25828 2.40755 11.1489 1.05249Z"
                          fill="#E33629"
                        />
                        <path
                          d="M0.813899 12.8749C1.09245 11.4944 1.55491 10.1575 2.1889 8.8999L7.3714 12.9224C6.69344 14.9189 6.69344 17.0834 7.3714 19.0799C5.64473 20.4132 3.91723 21.7532 2.1889 23.0999C0.601776 19.9407 0.117731 16.3412 0.813899 12.8749Z"
                          fill="#F8BD00"
                        />
                        <path
                          d="M16.3175 13.0376H31.1975C31.7065 15.8299 31.5688 18.7018 30.795 21.4326C30.0831 23.9438 28.7002 26.2135 26.795 27.9976C25.1225 26.6926 23.4425 25.3976 21.77 24.0926C22.5992 23.5333 23.3069 22.8123 23.8508 21.9729C24.3946 21.1335 24.7634 20.193 24.935 19.2076H16.3175C16.315 17.1526 16.3175 15.0951 16.3175 13.0376Z"
                          fill="#587DBD"
                        />
                        <path
                          d="M2.1875 23.1001C3.91583 21.7667 5.64333 20.4267 7.37 19.0801C8.03802 21.0406 9.30851 22.7398 11 23.9351C12.055 24.6807 13.2538 25.1984 14.52 25.4551C15.7676 25.6871 17.0474 25.6871 18.295 25.4551C19.539 25.2445 20.7252 24.7762 21.7775 24.0801C23.45 25.3851 25.13 26.6801 26.8025 27.9851C24.9722 29.6494 22.741 30.8098 20.3275 31.3526C17.6635 31.9788 14.8873 31.9488 12.2375 31.2651C10.1418 30.7055 8.18419 29.7191 6.4875 28.3676C4.69165 26.9418 3.22489 25.145 2.1875 23.1001Z"
                          fill="#319F43"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_217_861">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <svg
                        v-for="n in review.evaluation_value"
                        :key="n"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                          fill="var(--c-secondary)"
                        />
                      </svg>
                    </div>
                  </div>

                  <div class="testimonials__text tw-h-40 tw-overflow-auto">
                    {{ review.content }}
                  </div>
                  <div class="testimonials__name">{{ review.person_name }}</div>
                </div>
              </div>
            </div>

            <div class="testimonialsNav mt-60 md:mt-30">
              <button class="-prev text-white js-prev">
                <i class="icon-left-arrow"></i>
              </button>

              <div class="testimonialsPag text-white js-pagination !tw-w-[unset]"></div>

              <button class="-next text-white ml-20 js-next">
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="counter-section section-padding pt-60 pb-50"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div v-html="vars.titleHtml" class="mb-4 tw-items-center tw-text-center" />
      <div class="row justify-center text-center">
        <div class="col-xl-8 col-lg-9 col-md-10">
          <div
            class="overflow-hidden js-section-slider"
            data-gap="30"
            data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1"
            data-pagination="js-pagination"
            data-custom-pagination="true"
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="review in reviews" :key="review._id">
                <div class="testimonials -type-1" :style="`color: var(--c-${vars.textColor})`">
                  <div
                    class="testimonials__icon tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6"
                  >
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_217_861)">
                        <path
                          d="M11.1468 1.05274C7.94946 2.16191 5.19211 4.26716 3.27973 7.05924C1.36735 9.85133 0.400732 13.1831 0.52186 16.5652C0.642987 19.9472 1.84547 23.2013 3.9527 25.8494C6.05992 28.4975 8.9608 30.4001 12.2293 31.2777C14.8791 31.9615 17.6553 31.9915 20.3193 31.3652C22.7325 30.8232 24.9637 29.6637 26.7943 28.0002C28.6995 26.2161 30.0823 23.9464 30.7943 21.4352C31.5681 18.7044 31.7057 15.8326 31.1968 13.0402H16.3168V19.2127H24.9343C24.762 20.1972 24.393 21.1368 23.8491 21.9753C23.3053 22.8138 22.5979 23.534 21.7693 24.0927C20.717 24.7888 19.5307 25.2572 18.2868 25.4677C17.0391 25.6997 15.7594 25.6997 14.5118 25.4677C13.2472 25.2063 12.051 24.6844 10.9993 23.9352C9.30962 22.7392 8.04094 21.0401 7.37425 19.0802C6.69629 17.0837 6.69629 14.9193 7.37425 12.9227C7.84882 11.5233 8.63334 10.2491 9.66925 9.19524C10.8547 7.96711 12.3556 7.08923 14.0071 6.65793C15.6587 6.22663 17.3972 6.25857 19.0318 6.75024C20.3087 7.14222 21.4764 7.82708 22.4418 8.75024C23.4134 7.78357 24.3834 6.81441 25.3518 5.84274C25.8518 5.32024 26.3968 4.82274 26.8893 4.28774C25.4157 2.91643 23.686 1.84938 21.7993 1.14774C18.3635 -0.099786 14.6042 -0.133312 11.1468 1.05274Z"
                          fill="white"
                        />
                        <path
                          d="M11.1489 1.05249C14.6061 -0.134368 18.3654 -0.101725 21.8014 1.14499C23.6884 1.8514 25.4174 2.92358 26.8889 4.29999C26.3889 4.83499 25.8614 5.33499 25.3514 5.85499C24.3814 6.82332 23.4122 7.78832 22.4439 8.74999C21.4785 7.82683 20.3108 7.14197 19.0339 6.74999C17.3998 6.25659 15.6615 6.22281 14.0095 6.65235C12.3575 7.08188 10.8557 7.95814 9.66891 9.18499C8.63299 10.2388 7.84847 11.513 7.37391 12.9125L2.19141 8.89999C4.04643 5.22139 7.25828 2.40755 11.1489 1.05249Z"
                          fill="#E33629"
                        />
                        <path
                          d="M0.813899 12.8749C1.09245 11.4944 1.55491 10.1575 2.1889 8.8999L7.3714 12.9224C6.69344 14.9189 6.69344 17.0834 7.3714 19.0799C5.64473 20.4132 3.91723 21.7532 2.1889 23.0999C0.601776 19.9407 0.117731 16.3412 0.813899 12.8749Z"
                          fill="#F8BD00"
                        />
                        <path
                          d="M16.3175 13.0376H31.1975C31.7065 15.8299 31.5688 18.7018 30.795 21.4326C30.0831 23.9438 28.7002 26.2135 26.795 27.9976C25.1225 26.6926 23.4425 25.3976 21.77 24.0926C22.5992 23.5333 23.3069 22.8123 23.8508 21.9729C24.3946 21.1335 24.7634 20.193 24.935 19.2076H16.3175C16.315 17.1526 16.3175 15.0951 16.3175 13.0376Z"
                          fill="#587DBD"
                        />
                        <path
                          d="M2.1875 23.1001C3.91583 21.7667 5.64333 20.4267 7.37 19.0801C8.03802 21.0406 9.30851 22.7398 11 23.9351C12.055 24.6807 13.2538 25.1984 14.52 25.4551C15.7676 25.6871 17.0474 25.6871 18.295 25.4551C19.539 25.2445 20.7252 24.7762 21.7775 24.0801C23.45 25.3851 25.13 26.6801 26.8025 27.9851C24.9722 29.6494 22.741 30.8098 20.3275 31.3526C17.6635 31.9788 14.8873 31.9488 12.2375 31.2651C10.1418 30.7055 8.18419 29.7191 6.4875 28.3676C4.69165 26.9418 3.22489 25.145 2.1875 23.1001Z"
                          fill="#319F43"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_217_861">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <svg
                        v-for="n in review.evaluation_value"
                        :key="n"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                          fill="var(--c-secondary)"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    class="testimonials__text text-white tw-h-40 tw-overflow-auto"
                    :style="`color: var(--c-${vars.textColor})`"
                  >
                    {{ review.content }}
                  </div>
                  <div class="testimonials__name text-white">{{ review.person_name }}</div>
                </div>
              </div>
            </div>

            <div class="mt-60 md:mt-30 tw-flex tw-items-center tw-justify-center">
              <button
                class="sliderNav -prev js-prev n-link !tw-bg-transparent"
                :class="`tw-text-${vars.textColor}`"
                style="border-color: var(--c-secondary) !important"
              >
                <i class="icon-left-arrow"></i>
              </button>
              <button
                style="border-color: var(--c-secondary) !important"
                class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent"
                :class="`tw-text-${vars.textColor}`"
              >
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="counter-section section-padding pt-60 pb-50"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <h2 class="mb-4 tw-items-center tw-text-center">{{ vars.titleText }}</h2>
      <div class="row justify-center text-center">
        <div class="col-xl-8 col-lg-9 col-md-10">
          <div
            class="overflow-hidden js-section-slider"
            data-gap="30"
            data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1"
            data-pagination="js-pagination"
            data-custom-pagination="true"
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="review in reviews" :key="review._id">
                <div class="testimonials -type-1" :style="`color: var(--c-${vars.textColor})`">
                  <div
                    class="testimonials__icon tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6"
                  >
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_217_861)">
                        <path
                          d="M11.1468 1.05274C7.94946 2.16191 5.19211 4.26716 3.27973 7.05924C1.36735 9.85133 0.400732 13.1831 0.52186 16.5652C0.642987 19.9472 1.84547 23.2013 3.9527 25.8494C6.05992 28.4975 8.9608 30.4001 12.2293 31.2777C14.8791 31.9615 17.6553 31.9915 20.3193 31.3652C22.7325 30.8232 24.9637 29.6637 26.7943 28.0002C28.6995 26.2161 30.0823 23.9464 30.7943 21.4352C31.5681 18.7044 31.7057 15.8326 31.1968 13.0402H16.3168V19.2127H24.9343C24.762 20.1972 24.393 21.1368 23.8491 21.9753C23.3053 22.8138 22.5979 23.534 21.7693 24.0927C20.717 24.7888 19.5307 25.2572 18.2868 25.4677C17.0391 25.6997 15.7594 25.6997 14.5118 25.4677C13.2472 25.2063 12.051 24.6844 10.9993 23.9352C9.30962 22.7392 8.04094 21.0401 7.37425 19.0802C6.69629 17.0837 6.69629 14.9193 7.37425 12.9227C7.84882 11.5233 8.63334 10.2491 9.66925 9.19524C10.8547 7.96711 12.3556 7.08923 14.0071 6.65793C15.6587 6.22663 17.3972 6.25857 19.0318 6.75024C20.3087 7.14222 21.4764 7.82708 22.4418 8.75024C23.4134 7.78357 24.3834 6.81441 25.3518 5.84274C25.8518 5.32024 26.3968 4.82274 26.8893 4.28774C25.4157 2.91643 23.686 1.84938 21.7993 1.14774C18.3635 -0.099786 14.6042 -0.133312 11.1468 1.05274Z"
                          fill="white"
                        />
                        <path
                          d="M11.1489 1.05249C14.6061 -0.134368 18.3654 -0.101725 21.8014 1.14499C23.6884 1.8514 25.4174 2.92358 26.8889 4.29999C26.3889 4.83499 25.8614 5.33499 25.3514 5.85499C24.3814 6.82332 23.4122 7.78832 22.4439 8.74999C21.4785 7.82683 20.3108 7.14197 19.0339 6.74999C17.3998 6.25659 15.6615 6.22281 14.0095 6.65235C12.3575 7.08188 10.8557 7.95814 9.66891 9.18499C8.63299 10.2388 7.84847 11.513 7.37391 12.9125L2.19141 8.89999C4.04643 5.22139 7.25828 2.40755 11.1489 1.05249Z"
                          fill="#E33629"
                        />
                        <path
                          d="M0.813899 12.8749C1.09245 11.4944 1.55491 10.1575 2.1889 8.8999L7.3714 12.9224C6.69344 14.9189 6.69344 17.0834 7.3714 19.0799C5.64473 20.4132 3.91723 21.7532 2.1889 23.0999C0.601776 19.9407 0.117731 16.3412 0.813899 12.8749Z"
                          fill="#F8BD00"
                        />
                        <path
                          d="M16.3175 13.0376H31.1975C31.7065 15.8299 31.5688 18.7018 30.795 21.4326C30.0831 23.9438 28.7002 26.2135 26.795 27.9976C25.1225 26.6926 23.4425 25.3976 21.77 24.0926C22.5992 23.5333 23.3069 22.8123 23.8508 21.9729C24.3946 21.1335 24.7634 20.193 24.935 19.2076H16.3175C16.315 17.1526 16.3175 15.0951 16.3175 13.0376Z"
                          fill="#587DBD"
                        />
                        <path
                          d="M2.1875 23.1001C3.91583 21.7667 5.64333 20.4267 7.37 19.0801C8.03802 21.0406 9.30851 22.7398 11 23.9351C12.055 24.6807 13.2538 25.1984 14.52 25.4551C15.7676 25.6871 17.0474 25.6871 18.295 25.4551C19.539 25.2445 20.7252 24.7762 21.7775 24.0801C23.45 25.3851 25.13 26.6801 26.8025 27.9851C24.9722 29.6494 22.741 30.8098 20.3275 31.3526C17.6635 31.9788 14.8873 31.9488 12.2375 31.2651C10.1418 30.7055 8.18419 29.7191 6.4875 28.3676C4.69165 26.9418 3.22489 25.145 2.1875 23.1001Z"
                          fill="#319F43"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_217_861">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <svg
                        v-for="n in review.evaluation_value"
                        :key="n"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                          fill="var(--c-secondary)"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    class="testimonials__text text-white tw-h-40 tw-overflow-auto"
                    :style="`color: var(--c-${vars.textColor})`"
                  >
                    {{ review.content }}
                  </div>
                  <div class="testimonials__name text-white">{{ review.person_name }}</div>
                </div>
              </div>
            </div>

            <div class="mt-60 md:mt-30 tw-flex tw-items-center tw-justify-center">
              <button
                class="sliderNav -prev js-prev n-link !tw-bg-transparent"
                :class="`tw-text-${vars.textColor}`"
                style="border-color: var(--c-secondary) !important"
              >
                <i class="icon-left-arrow"></i>
              </button>
              <button
                style="border-color: var(--c-secondary) !important"
                class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent"
                :class="`tw-text-${vars.textColor}`"
              >
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme7GoogleReview',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      reviews: null,
    };
  },

  created() {
    const parsedReviews = this.parseFormV2(this.vars.googleReviews);
    this.reviews = parsedReviews?.reviews?.filter((review: any) => review.content?.trim());
  },
});
</script>

<style scoped>
.testimonials__text::-webkit-scrollbar {
  width: 4px;
  background-color: transparent;
}

.testimonials__text::-webkit-scrollbar-thumb {
  background-color: var(--c-primary);
  border-radius: 4px;
  opacity: 0.7;
}

.testimonials__text::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>
